import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell, googleLogin } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account created!");
      navigate("/onboard", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your Vorra account" subtitle="Start listing or messaging in minutes.">
      <Button type="button" onClick={googleLogin} variant="outline" className="w-full h-11 mb-4" data-testid="google-register-btn">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-4 h-4 mr-2" />
        Continue with Google
      </Button>
      <div className="relative my-4 text-center"><span className="bg-background px-2 text-xs text-muted-foreground relative z-10">or with email</span><div className="absolute inset-0 top-1/2 border-t border-border" /></div>
      <form onSubmit={submit} className="space-y-4">
        <div><Label>Full name</Label><Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1" /></div>
        <div><Label>Email</Label><Input data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" /></div>
        <div><Label>Password</Label><Input data-testid="register-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1" /></div>
        <Button type="submit" disabled={loading} className="w-full h-11 bg-primary text-white" data-testid="register-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">Already have an account? <Link to="/login" className="text-accent font-medium">Log in</Link></p>
    </AuthShell>
  );
}
